module.exports = __webpack_public_path__ + "img/frame-data-xl.4791cc38.png";